module.exports = __webpack_public_path__ + "static/media/img_1.e6380c06.png";